export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-8">
        <div className="mb-20">
          <span className="text-xs uppercase tracking-widest font-medium" style={{ color: '#5A9999', letterSpacing: '2px' }}>
            About TEAL SRL
          </span>
        </div>
        
        <div className="mb-16">
          <h2 className="text-6xl leading-tight mb-8" style={{ fontFamily: 'Playfair Display, serif', color: '#1C2833' }}>
            <span className="font-normal">A team of experts </span>
            <span className="inline-flex items-center mx-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/fff3f2b1576aae5c0ebd060a0567a928.jpg" 
                alt="Team collaboration"
                className="w-14 h-14 rounded-full object-cover"
              />
            </span>
            <br />
            <span className="font-normal">developing modern </span>
            <span className="inline-flex items-center mx-3">
              <img 
                src="https://readdy.ai/api/search-image?query=clean%20modern%20code%20editor%20interface%20showing%20Swift%20programming%20language%2C%20iOS%20development%20environment%2C%20Xcode%20IDE%20with%20elegant%20syntax%20highlighting%2C%20teal%20accent%20colors%2C%20minimalist%20developer%20workspace%2C%20professional%20software%20engineering%20screenshot&width=80&height=60&seq=about-code-1&orientation=landscape" 
                alt="Code editor"
                className="w-20 h-14 rounded-lg object-cover"
              />
            </span>
            <br />
            <span className="italic font-light">applications</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-2 gap-20">
          <div>
            <p className="text-lg leading-relaxed" style={{ color: '#4F4F4F', lineHeight: '1.8' }}>
              TEAL SRL specializes in creating cutting-edge iOS applications that prioritize user experience and device security. Our team combines technical expertise with creative innovation to deliver products that stand out in the competitive mobile app marketplace.
            </p>
          </div>
          <div>
            <p className="text-lg leading-relaxed" style={{ color: '#4F4F4F', lineHeight: '1.8' }}>
              With a focus on VPN and device optimization solutions, we help millions of users protect their privacy and maintain peak device performance. Our commitment to excellence drives every line of code we write and every feature we design.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}